/* eslint-disable default-param-last */
import { EDIT_USER } from 'constants/constants';

export default (state = {}, action) => {
  switch (action.type) {
    case EDIT_USER:
      return state.map((user) => {
        if (user.id === action.payload.id) {
          return {
            ...user,
            ...action.payload
          };
        }
        return user;
      });
    default:
      return state;
  }
};
